import Requester from "../helpers/Requester";
import App from "../layouts/app";
import { router } from "@inertiajs/react";
import ContentWrapper from "../components/ContentWrapper";
import PageTitle from "../components/PageTitle";
import PageForm from "../components/PageForm";
import { Page } from "./Pages";

export default function PageEdit({ page }: { page: Page }) {

    const savePage = (data: any) => {
        const requester = new Requester();

        requester.post(requester.getUrl(`api/pages/${page.id}`), data).then((response) => {
            router.visit(`/admin/pages`);
        }).catch((error) => {
            alert("Error updating page: " + error.message);
        })
    }

    return (
        <App>
            <PageTitle title="Pages" />
            <ContentWrapper>
                <PageForm onSubmit={savePage} page={page} />
            </ContentWrapper>
        </App >
    )
}